<template>
  <div class='label'>
    <div :class="['label', { colorBoolean }]">
      {{ item[column.name] }}
    </div>
  </div>
</template>

<script>
import { CONFIGURATION } from '@/constants/configuration';

export default {
  name: 'BucketStatusTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    colorBoolean() {
      return !(this.item[this.column.name] === CONFIGURATION.CLOUD_STATUS.private);
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.label {
  padding-top: $space-2-5;
  height: 20px;
  width: 41px;
  color: var(--text-primary);
  font-family: $font-family-regular;
  text-transform: capitalize;
  font-size: $font-size-base;
  letter-spacing: 0;
  line-height: 20px;

  &.colorBoolean {
    height: 20px;
    width: 54px;
    color: var(--severity-critical);
    font-family: $font-family-regular;
    text-transform: capitalize;
    font-size: $font-size-base;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 20px;
  }
}
</style>
